<script>
	
/**
 * ESTE COMPONENTE ASIGNA TITULOS A LA TABLA 
 * @propiedad {String} align    Alineación [left|right|center]  Default left
 * @propiedad {String} width    Ancho de la celda 100px
 * @propiedad {String} order    Nombre del campo a ordenar      Default false
 * @propiedad {String} title    Titulo de la celda
 * 
 * @ejemplo
 * <DatagridTitle width='100px' order="codigo_usuario" title='Código' align='right'/>
 */


    import { getContext,onMount } from 'svelte';
    import { datagrid } from './Datagrid.js';
    import {breakpoint, platform} from './MediaQuery.svelte';

    export let align='left';    // ALINEACIÓN LEFT | RIGHT | CENTER
    export let width=false;     //
    export let order=false;
    export let title=false;

    let uid=false;
    uid = getContext('uid');
    let index=0;
    let indexSearch=false;

    if(order!==false) {
        indexSearch = $datagrid[uid].titles.findIndex( s => s.order == order )
        
        if(indexSearch==-1)
        {
            $datagrid[uid].titles=[...$datagrid[uid].titles, {name:title,order:order}]
        }
    }


    function orderAction() {
        if(order==$datagrid[uid].order)
        {
            $datagrid[uid].dir=($datagrid[uid].dir=='ASC')?'DESC':'ASC';
        } else {
            $datagrid[uid].order=order;
            $datagrid[uid].dir='ASC';
        }
        

    }

</script>

<!-- svelte-ignore missing-declaration -->
<!-- svelte-ignore a11y-missing-attribute -->


{#if $breakpoint=='lg' || $breakpoint=='xl' || $breakpoint=='xxl'}
    <th class='align-middle {$$props.class}' style='width:{width}'
    class:text-start="{align === 'left'}"
    class:text-end="{align === 'right'}"
    class:text-center="{align === 'center'}"
    >
        {#if order!==false}
            {#if order != $datagrid[uid].order}
                <a on:click={()=>orderAction()}>
                    {title}
                    <i class="bi bi-sort-down opacity-25"></i>
                </a>
            {:else}
                <a on:click={()=>orderAction()}>
                    {title}
                    <i class="bi"
                    class:bi-sort-down="{$datagrid[uid].dir == 'ASC'}"
                    class:bi-sort-up-alt="{$datagrid[uid].dir == 'DESC'}"
                    ></i>
                </a>
            {/if}
        {:else}
            {title}
        {/if}

    </th>
{/if}



<style>
    TH {
        user-select: none;
        color:#fff;
        text-decoration: none;
        font-weight: normal;
    }    
    A {
        user-select: none;
        color:#fff;
        text-decoration: none;
        cursor:pointer;
    }
    A:hover {
        user-select: none;
        color:#fff;
        text-decoration: none;
    }    
</style>